import api from '@/utils/api';

/**
 * Note: when the environment is changed the app is redrawn by using the :key property on the
 * App.vue
 */
export default {
  namespaced: true,
  state: {
    appLoad: false,
    data: null,
  },
  getters: {
    isLive: (state) => state.data.environment === 'live',
    get: (state) => state.data,
  },
  mutations: {
    setData(state, payload) {
      state.data = payload;
      state.appLoad = true;
    },
  },
  actions: {
    async loadEnvironment({ commit }, payload) {
      commit('setData', (await api.get(`/${payload}`)).data);
    },
    /**
     * This is an initial environment loader, once done once stop doing it again!
     *
     * @param commit
     * @param state
     * @returns {Promise<void>}
     */
    async onLoad({ commit, state }) {
      if (state.appLoad) {
        return;
      }
      const env = localStorage.getItem('environment') ?? 'live';
      commit('setData', (await api.get(`/${env}`)).data);
    },
  },
};
